import { createReducer } from '@reduxjs/toolkit';
import type { IPortalAccount } from '../../api/domain';
import { fetchPortalAccountsSuccess, fetchUserPortalAccountSuccess } from './portal-account-api-actions';

interface IPortalAccountApiState {
    portalAccount?: IPortalAccount;
    portalAccounts: IPortalAccount[];
}
export type { IPortalAccountApiState };

export const initialState: IPortalAccountApiState = {
    portalAccounts: [],
};

export const portalAccountApiReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(fetchUserPortalAccountSuccess, (state, { payload: portalAccount }) => {
            state.portalAccount = portalAccount;
        })
        .addCase(fetchPortalAccountsSuccess, (state, { payload: portalAccounts }) => {
            state.portalAccounts = portalAccounts;
        });
});
